;(function () {
  'use strict';

  /**
   * SSOログインモーダル
   */
  var ssoModal = {
    /**
     * 初期化
     */
    init: function (options) {
      var config = $.extend({
        dialog: '.ui-dialog--sso',            // ダイアログのセレクタ
        sideMargin: 15,                       // 左右の余白 [px]
        openButton: '.js-dialog--sso__open',  // ダイアログの表示ボタン
        closeButton: '.js-dialog--sso__close' // ダイアログの非表示ボタン
      }, options);

      if ($('body.sp-viewport').length) {
        /*
        // sp版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargin * 2),
          position: {
            my: 'top',
            at: 'bottom+20',
            of: $('#header')
          },
          dialogClass: 'dialog-contact',
          show: 'fade',
          hide: 'fast'
        });
        */
      } else {
        // pc版モーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: 800,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-sso',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * ログインモーダル 表示イベント
       */
      $(config.openButton).on('click', function () {
        $(config.dialog).dialog('open');
        return false;
      });

      /**
       * ログインモーダル 非表示イベント
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });

      //ダイアログ以外の場所をタップしたらダイアログが消える
      $( document ).on('click', '.ui-widget-overlay', function(){
        $(config.dialog).dialog('close');
        //ダイアログが消えたら、スクロール可能に
        $(window).off('.noScroll');
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    ssoModal.init();
  });
}.call(this));
